//PrintDataTable.tsx =================================================
import "../Util/Prototypes";

import * as Default from "../Default";
import * as PrintDataTable from "./PrintDataTable";
import * as Search from "../Search/Search";
import * as Settings from "../Settings";
import * as Util from "../Util/Util";
import * as Util_App from "../Util/Util_App";

import React from "react";

export let numRow: number;

interface iDataRec {
   label: string;
   values: string[];
}

let data: iDataRec[];

//Build label and value list for selected feature.
export function buildLableValueList() {
   let i: number;
   let j: number;
   let k: number;
   let feature: __esri.Graphic;
   let field: Util_App.iField;
   let fields: Util_App.iField[];
   let dataRec: iDataRec;
   let values: string[];
   const lay: Search.iLayer = Search.layers[Search.activeLayerIndex];
   const fs = lay.fs;
   data = [];

   numRow = 0;

   //Single feature selected.
   if (lay.totRec === 1) {
      feature = fs.features[0];
      fields = Util_App.getFeatureValues(fs, feature, lay.name);

      for (j = 0; j < fs.fields.length; j++) {
         field = fields[j];

         if (!lay.spec.doNotExport.Contains(field.name)) {
            if (Settings.security.accessLevel >= field.accessLevel) {
               dataRec = { label: field.alias, values: [field.value] };
               data.Add(dataRec);
            }
         }
      }

   } else { //Multiple features selected.
      const numRec: number = Math.min(lay.numRec, 10);
      const endRec: number = lay.begRec + numRec - 1;

      //Process all records.
      for (i = lay.begRec; i <= endRec; i++) {
         feature = fs.features[i];
         fields = Util_App.getFeatureValues(fs, feature, lay.name);
         values = [];

         for (const headingField of lay.spec.headingFields) {
            for (k = 0; k < fs.fields.length; k++) {
               field = fields[k];

               if (headingField.toLowerCase() === field.name.toLowerCase()) {
                  if (Settings.security.accessLevel >= field.accessLevel) {
                     values.Add(field.value);
                  }
               }
            }
         }

         dataRec = { label: (i + 1).toString(), values: values };
         data.Add(dataRec);
      }
   }
   numRow = Util.parseInteger(((data.length / 2) + 0.5).toString());
}

interface iProps {
}

//Get table row value.
function getTableRowValue(values: string[]): JSX.Element[] {
   const jsx: JSX.Element[] = [];

   values.map(function (value: string, i: number) {
      if (i > 0) {
         jsx.push(
            <span key={Util.uid()}><br />{value}</span>,
         );
      } else {
         jsx.push(
            <span key={Util.uid()}>{value}</span>,
         );
      }
   });

   return jsx;
}

export function Render(props: iProps) {
   Util.logMsg("Top of PrintDataTable Render");

   //Set refresh method.
   const [ignored, refresh] = React.useReducer((x: number) => x + 1, 0);

   //Component did mount.
   React.useEffect(() => {
   }, []);

   const styles: Default.iStyles = {
      table: { width: '100%', fontWeight: 500, border: '1px solid silver', borderCollapse: 'collapse', borderSpacing: 0, fontFamily: 'Roboto, Helvetica, Arial, Verdana' },
      c1: { lineHeight: '1.15rem', border: '1px solid silver', textAlign: 'left', padding: 2, paddingLeft: 3, paddingRight: 3, backgroundColor: '#FFFFF0', color: 'black', fontSize: Settings.printDataTableFontSize },
      c2: { lineHeight: '1.15rem', border: '1px solid silver', textAlign: 'left', padding: 2, paddingLeft: 3, paddingRight: 3, backgroundColor: '#F1F4F8', color: 'black', fontSize: Settings.printDataTableFontSize },
   };

   let i: number;
   let j: number;
   let row: number;
   let alias2: string;
   let contentValue2: JSX.Element[];
   let ct: React.CSSProperties;
   let c1: React.CSSProperties = styles.c1;
   let c2: React.CSSProperties = styles.c2;

   const jsx = [];

   for (row = 1; row < (PrintDataTable.numRow + 1); row++) {
      i = row - 1;
      j = i + PrintDataTable.numRow;

      //Alternate background color styles.
      ct = c1;
      c1 = c2;
      c2 = ct;

      //Set right column values.
      alias2 = "";
      contentValue2 = null;

      if (j < data.length) {
         alias2 = data[j].label;
         contentValue2 = getTableRowValue(data[j].values);
      }

      //Create row.
      jsx.push(
         <tr key={Util.uid()}>
            <td style={c1}>{data[i].label}</td>
            <td style={c1}>{getTableRowValue(data[i].values)}</td>

            <td style={c2}>{alias2}</td>
            <td style={c2}>{contentValue2}</td>
         </tr>,
      );
   }

   return (
      <table style={styles.table}>
         <tbody>
            {jsx}
         </tbody>
      </table>
   ); //end return.

} //end function.
